import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./IosAppBanner.scss";

const APP_STORE_URL =
  "https://apps.apple.com/ua/app/cvanto/id6775982237";

function isIOSDevice() {
  const ua = window.navigator.userAgent || "";
  const platform = window.navigator.platform || "";

  return (
    /iPhone|iPad|iPod/i.test(ua) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export default function IosAppBanner() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const closedAt = localStorage.getItem(
  "cvanto_ios_app_banner_closed_at"
);

const ONE_DAY = 24 * 60 * 60 * 1000;

const isDismissed =
  closedAt &&
  Date.now() - Number(closedAt) < ONE_DAY;

    if (
    location.pathname === "/" &&
    isIOSDevice() &&
    !isDismissed
    ) {
        const timer = setTimeout(() => {
        setVisible(true);
        }, 700);

        return () => clearTimeout(timer);
    }

    setVisible(false);
    }, [location.pathname]);

  const closeBanner = () => {
  localStorage.setItem(
    "cvanto_ios_app_banner_closed_at",
    Date.now().toString()
  );

  setVisible(false);
};

  if (!visible) return null;

  return (
    <div className="ios-app-banner">
      <button
        type="button"
        className="ios-app-banner__close"
        onClick={closeBanner}
        aria-label="Закрити"
      >
        ×
      </button>

      <div className="ios-app-banner__top">
        <img
        src="/apple-touch-icon.png"
        alt="Cvanto"
        className="ios-app-banner__icon"
        />

        <div className="ios-app-banner__text">
          <div className="ios-app-banner__title">Встановіть застосунок на iOS</div>
          <div className="ios-app-banner__subtitle">
            Купувати, продавати та спілкуйтесь зручніше у додатку Cvanto
          </div>
        </div>
      </div>

      <a
        href={APP_STORE_URL}
        className="ios-app-banner__button"
        target="_blank"
        rel="noreferrer"
      >
        Завантажити
      </a>
    </div>
  );
}